import { render, staticRenderFns } from "./PeiHistoryRow.vue?vue&type=template&id=38b72172&scoped=true"
import script from "./PeiHistoryRow.vue?vue&type=script&lang=js"
export * from "./PeiHistoryRow.vue?vue&type=script&lang=js"
import style0 from "./PeiHistoryRow.vue?vue&type=style&index=0&id=38b72172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b72172",
  null
  
)

export default component.exports